import {ParameterSetModalState} from "../../../../components/configs/parametersets/modal/ParameterSetModalState";
import CodeParamsStore from "../../../../stores/domain/parameters/CodeParamsStore";
import ScanParamsStore from "../../../../stores/domain/parameters/ScanParamsStore";
import {CodeParamsTypeSelectState} from "../../../../components/elements/parameters/codeType/CodeParamsTypeSelectState";
import {ScanParamsTypeSelectState} from "../../../../components/elements/parameters/scanType/ScanParamsTypeSelectState";
import CountParamsStore from "../../../../stores/domain/parameters/CountParamsStore";
import PremiumParamsStore from "../../../../stores/domain/parameters/PremiumParamsStore";
import CustomParamsStore from "../../../../stores/domain/parameters/CustomParamsStore";
import GS1ParamsStore from "../../../../stores/domain/parameters/GS1ParamStore";
import {CountParamsTypeSelectState} from "../../../../components/elements/parameters/countType/CountParamsTypeSelectState";
import {GS1ParamsTypeSelectState} from "../../../../components/elements/parameters/gs1Type/GS1ParamsTypeSelectState";
import {
  PremiumParamsTypeSelectState
} from "../../../../components/elements/parameters/premiumType/PremiumParamsTypeSelectState";
import {CustomParamsTypeSelectState} from "../../../../components/elements/parameters/customType/CustomParamsTypeSelectState";
import ParameterStore from "../../../../stores/domain/ParameterStore";
import {batchTypesConstatns} from "../../../../utils/constants";

export async function initParameterSelectOptions(rootStore) {
    const codeParamsStore = CodeParamsStore.create({
        storeUuid: "codeParamsStore"
    })
    const scanParamsStore = ScanParamsStore.create({
        storeUuid: "scanParamsStore"
    })
    const countParamsStore = CountParamsStore.create({
        storeUuid: "countParamsStore"
    })
    const premiumParamsStore = PremiumParamsStore.create({
        storeUuid: "premiumParamsStore"
    })
    const customParamsStore = CustomParamsStore.create({
        storeUuid: "customParamsStore"
    })
    const gs1ParamsStore = GS1ParamsStore.create({
        storeUuid: "gs1"
    })
    await rootStore.rootUiStore.attachPageState('codeParamsStore', codeParamsStore)
    await rootStore.rootUiStore.attachPageState('scanParamsStore', scanParamsStore)
    await rootStore.rootUiStore.attachPageState('countParamsStore', countParamsStore)
    await rootStore.rootUiStore.attachPageState('premiumParamsStore', premiumParamsStore)
    await rootStore.rootUiStore.attachPageState('customParamsStore', customParamsStore)
    await rootStore.rootUiStore.attachPageState('gs1ParamsStore', gs1ParamsStore)
}

export async function initParameterSetModal(rootStore, groupSelectState, isView, isRemovedParameterSet = false) {
    const parameterSetSelectState = rootStore.rootUiStore.parameterSetSelectState;
    await parameterSetSelectState.store.init();
    const parameterExtendedDataSelectStore = rootStore.rootUiStore.parameterExtendedDataSelectStore;
    parameterExtendedDataSelectStore.store.init();

    const parameterSetModalState =  ParameterSetModalState.create({
        groupSelectStore: groupSelectState,
        parameterSetSelectState: parameterSetSelectState,
        parameterStore: ParameterStore.create({
            storeUuid: "parameterStore"
        }),
        codeParamsTypeSelectState: CodeParamsTypeSelectState.create({
            selectStateUuid: "codeParamsTypeSelectState",
            store: rootStore.rootUiStore.codeParamsStore
        }),
        scanParamsTypeSelectState: ScanParamsTypeSelectState.create({
            selectStateUuid: "scanParamsTypeSelectState",
            store: rootStore.rootUiStore.scanParamsStore
        }),
        countParamsTypeSelectState: CountParamsTypeSelectState.create({
            selectStateUuid: "countParamsTypeSelectState",
            store: rootStore.rootUiStore.countParamsStore
        }),
        premiumParamsTypeSelectState: PremiumParamsTypeSelectState.create({
            selectStateUuid: "premiumParamsTypeSelectState",
            store: rootStore.rootUiStore.premiumParamsStore
        }),
        customParamsTypeSelectState: CustomParamsTypeSelectState.create({
            selectStateUuid: "customParamsTypeSelectState",
            store: rootStore.rootUiStore.customParamsStore
        }),
        gs1ParamsTypeSelectState: GS1ParamsTypeSelectState.create({
            selectStateUuid: "gs1ParamsTypeSelectState",
            store: rootStore.rootUiStore.gs1ParamsStore
        }),
        parameterExtendedDataSelectStore:parameterExtendedDataSelectStore,
        isView: isView,
        isRemovedParameterSet: isRemovedParameterSet
    });
    return parameterSetModalState;
}

export function addParameterSetToCode(state) {
    if (!state.parameterSetModalState.noParameterSetOpen && state.parameterSetModalState.doesParamsHaveValues()) {
        state.parameters.setParameters("codeParamType",state.parameterSetModalState.codeParamsTypeSelectState.selectedCodeParameters.map((param) => param.uuid))
        state.parameters.setParameters("scanParamType",state.parameterSetModalState.scanParamsTypeSelectState.selectedScanParameters.map((param) => param.uuid))
        state.parameters.setParameters("countParamType",state.parameterSetModalState.countParamsTypeSelectState.selectedCountParameters.map((param) => param.uuid))
        state.parameters.setParameters("premiumParamType",state.parameterSetModalState.premiumParamsTypeSelectState.selectedPremiumParameters.map((param) => param.uuid))
        state.parameters.setParameters("customParamType",state.parameterSetModalState.customParamsTypeSelectState.selectedCustomParameters.map((param) => param.uuid))
        state.parameters.setParameters("gs1ParamType",state.parameterSetModalState.gs1ParamsTypeSelectState.selectedGS1Parameters.map((param) => param.uuid))
        state.parameters.setParameters("edParamType",state.parameterSetModalState.parameterExtendedDataSelectStore.selectedExtendedData.map((param) => param.uuid))
        state.parameters.batchCodeParamTypeLock = state.parameterSetModalState.batchCodeParamTypeLock
        state.parameters.batchScanParamTypeLock = state.parameterSetModalState.batchScanParamTypeLock
        state.parameters.batchCountParamTypeLock = state.parameterSetModalState.batchCountParamTypeLock
        state.parameters.batchPremiumParamTypeLock = state.parameterSetModalState.batchPremiumParamTypeLock
        state.parameters.batchCustomParamTypeLock = state.parameterSetModalState.batchCustomParamTypeLock
        state.parameters.batchGS1ParamTypeLock = state.parameterSetModalState.batchGS1ParamTypeLock
        state.parameters.batchEDParamTypeLock = state.parameterSetModalState.batchEDParamTypeLock
    } else if (state.parameterSetModalState.noParameterSetOpen || !state.parameterSetModalState.doesParamsHaveValues()) {
        state.parameters.clearParams()
        if(state.parameterSetModalState.noParameterSetOpen) {
            state.parameterSetModalState.clearParameters(false)
        } else {
            state.parameterSetModalState.clearParameters(true)
        }
        if(state.batchType === batchTypesConstatns.EDIT) {
            state.parameterSetModalState.isRemovedParameterSet = true
        }
    }
}
